import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaHome, FaTools, FaEnvelope, FaPhone, FaMapMarkerAlt, FaGlobe, FaClock } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import NikdipLogo from './NikdipLogo';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer-enhanced">
      <Container>
        <Row className="py-5">
          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <div className="footer-brand">
              {/* <div className="mb-4">
                <NikdipLogo/>
              </div> */}
              <h4 className="text-white mb-3">NIKDIP Multinational</h4>
              <p className="footer-description">
                Leading provider of industrial water treatment solutions for Africa and global markets. 
                Delivering excellence in chemical supply, technical services, and engineering solutions.
              </p>
              <div className="footer-social mt-4">
                <div className="d-flex align-items-center mb-2">
                  <FaGlobe className="me-2 text-info" />
                  <span className="small">Serving Africa & Global Markets</span>
                </div>
                <div className="d-flex align-items-center">
                  <FaClock className="me-2 text-info" />
                  <span className="small">24/7 Emergency Support Available</span>
                </div>
              </div>
            </div>
          </Col>
          
          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-links">
              <li><RouterLink to="/" className="footer-link" onClick={scrollToTop}><FaHome className="me-2" />Home</RouterLink></li>
              <li><RouterLink to="/services" className="footer-link" onClick={scrollToTop}><FaTools className="me-2" />Services</RouterLink></li>
              <li><RouterLink to="/contact" className="footer-link" onClick={scrollToTop}><FaEnvelope className="me-2" />Contact</RouterLink></li>
              <li><RouterLink to="/about" className="footer-link" onClick={scrollToTop}><FaGlobe className="me-2" />About Us</RouterLink></li>
            </ul>
          </Col>
          
          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <h5 className="footer-heading">Get In Touch</h5>
            <div className="footer-contact">
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <strong>Email:</strong><br />
                  victor.o@nikdipmultinational.com<br />
                </div>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <strong>Phone:</strong>
                  <br />
                  +234-9061743394
                  <br />
                  +234-8131210262
                  <br />
                  +234-8066638387
                  <br />
                  <small >Mon-Fri: 8AM-6PM</small>
                </div>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <strong>Location:</strong><br />
                  No. 06, WALE ALOMO CLOSE,
                  <br />
                  OFF BALOGUN ROAD,
                  <br />
                  IJU-ISHAGA, LAGOS STATE. NIGERIA.
                  <br />
                  {/* <small>Global Operations</small> */}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        
        <hr className="footer-divider" />
        
        <Row className="py-3">
          <Col md={6} className="text-center text-md-start mb-2 mb-md-0">
            <p className="footer-copyright mb-0">
              &copy; {new Date().getFullYear()} NIKDIP Multinational Company. All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <p className="footer-bottom mb-0">
              <small>Industrial Water Treatment Solutions Since 2024</small>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
